<template>
  <div
    :class="[
      'tva-simple-button',
      config.buttonType,
      { active: active },
      { 'only-icon': !content },
      { 'with-icon': content && config.icon }
    ]"
    @click="active = !active"
  >
    <span v-if="content">{{ content }}</span>
    <svgicon
      :class="['tva-simple-button-icon']"
      v-if="config.icon"
      icon="actions-navigation-add"
      width="20"
      height="20"
    ></svgicon>
  </div>
</template>
<script>
import "@/compiled-icons/actions-navigation-add";
export default {
  props: ["content", "config"],
  data() {
    return {
      active: false
    };
  }
};
</script>
<style lang="scss" scoped></style>
